import Vue from 'vue'

import formatDateTime from '@/filters/formatDateTime'

Vue.filter("formatDateTime", formatDateTime)
